<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">Сборка мебели</div>
                    </div>
                    <table cellpadding="0" cellspacing="0">
                      <thead>
                      <tr>
                        <td>Наименование категории</td>
                        <td>Цена, руб.</td>
                        <td>Зар. плата, руб.</td>
                        <td>Надбавка клиенту за проезд (ночной тариф), руб.</td>
                        <td>Надбавка рабочему за проезд (ночной тариф), руб.</td>
                        <td>Минимальная продолжительность, час.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Изменить" v-for="category in furnitureCategories" @value="category"
                          @key="category.id" @click="openFurnitureCategory(category.id)" v-if="!category.removed">
                        <td class="name">{{ category.name }}</td>
                        <td>{{ category.price }}</td>
                        <td>{{ category.salary }}</td>
                        <td>{{ category.clientSurcharge }}</td>
                        <td>{{ category.workerSurcharge }}</td>
                        <td>{{ category.minDuration }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'FurnitureCategories',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      furnitureCategories: []
    }
  },

  mounted () {
    api
      .getFurnitureCategories()
      .then(furnitureCategories => {
        if (furnitureCategories) {
          this.furnitureCategories = []
          this.furnitureCategories = furnitureCategories
        }
      })

    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')
  },

  methods: {
    openFurnitureCategory (id) {
      this.$router.push({ name: 'FurnitureCategory', params: { id: id } })
    }
  }
}
</script>
